<template>
  <section :class="['Panel', {'Panel--opened': opened !== null}]" v-click-outside="onClose">
    <!-- <button class="MobileBtn" @click="onMobileBtn()">
      <div class="MobileBtn-bg"></div>
      <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.65 13L10 4.96491L2.35 13L2.16256e-07 10.5263L10 -8.74228e-07L20 10.5263L17.65 13Z" fill="black"/>
      </svg>
    </button> -->
    <div class="Panel-wrapper">

      <nav class="PanelNav">
        <CloseButton @click="opened = null" v-if="opened !== null"/>
        <!-- <a @click="opened = null" v-if="opened !== null" class="Panel-close">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="white" xmlns="http://www.w3.org/2000/svg">
            <rect x="4.24261" y="6.75736" width="3" height="15" rx="1.5" transform="rotate(-45 4.24261 6.75736)"/>
            <rect x="14.8492" y="4.63604" width="3" height="15" rx="1.5" transform="rotate(45 14.8492 4.63604)"/>
          </svg>
        </a> -->
        <a @click="opened = 'collage'" :class="['PanelNav-left', {'open': opened === 'collage'}]">
          collage
          <span class="PanelNav-tick"></span>
        </a>
        <a @click="opened = 'bg'" :class="['PanelNav-right', {'open': opened === 'bg'}]">
          espace
          <span class="PanelNav-tick"></span>
        </a>
      </nav>

      <div class="Panel-content Panel-collage" v-show="opened === 'collage'">
        <ul class="PanelList">
          <li v-for="c in collages" :key="c.uid" @click="onClickCollage(c)"> 
            <div class="Marker" v-if="collage.sentence.uid === c.uid">
              <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2175 7.31798C17.8033 6.73219 18.7531 6.73219 19.3389 7.31798C19.9246 7.90376 19.9246 8.85351 19.3389 9.4393L18.9853 9.79285L18.6317 10.1464L8.3787 20.3995L2.36829 14.389L2.01474 14.0355L1.66118 13.6819C1.0754 13.0962 1.0754 12.1464 1.66118 11.5606C2.24697 10.9748 3.19672 10.9748 3.7825 11.5606L4.13606 11.9142L4.48961 12.2677L8.3787 16.1568L16.5104 8.02508L16.864 7.67153L17.2175 7.31798Z"/>
              </svg>
            </div>
            <div class="Marker Marker--inactive" v-else></div>
            <!-- <img :src="c.url" :alt="c.uid"> -->
            <LazyLoadImage :source="c.url" :alt="c.title"/>
          </li>
        </ul>
      </div>
      <div class="Panel-content Panel-bg" v-show="opened === 'bg'">
        <ul class="PanelList">
          <li :class="['UploadImage', {'UploadImage--active': collage.bg.uid === image.uid}]" @click="image.dataUrl ? onClickBg(image) : null">
            <h3>Photo Importée</h3>
            <div class="PanelList-imagewrapper">
              <div class="PanelList-overlay"></div>
              <div class="UploadImage-actions">
                <image-uploader
                  :preview="false"
                  :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                  :capture="false"
                  :debug="1"
                  doNotResize="gif"
                  :maxWidth="1920"
                  :maxHeight="1920"
                  :autoRotate="true"
                  outputFormat="verbose"
                  @input="setImage"
                >
                  <label for="fileInput" slot="upload-label">
                    <div class="Marker Marker--plus">
                      <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                        <path clip-rule="evenodd" d="M6 13.5C6 14.3284 6.67157 15 7.5 15C8.32843 15 9 14.3284 9 13.5V9H13.5C14.3284 9 15 8.32843 15 7.5C15 6.67157 14.3284 6 13.5 6H9V1.5C9 0.671573 8.32843 0 7.5 0C6.67157 0 6 0.671573 6 1.5V6H1.5C0.671573 6 0 6.67157 0 7.5C0 8.32843 0.671573 9 1.5 9H6V13.5Z"/>
                      </svg>
                    </div>
                    <!-- <span class="upload-caption">{{ hasImage ? 'Replace' : 'Upload' }}</span> -->
                  </label>
                </image-uploader>
                <div class="Marker" v-if="collage.bg.uid === image.uid">
                  <svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd" d="M17.2175 7.31798C17.8033 6.73219 18.7531 6.73219 19.3389 7.31798C19.9246 7.90376 19.9246 8.85351 19.3389 9.4393L18.9853 9.79285L18.6317 10.1464L8.3787 20.3995L2.36829 14.389L2.01474 14.0355L1.66118 13.6819C1.0754 13.0962 1.0754 12.1464 1.66118 11.5606C2.24697 10.9748 3.19672 10.9748 3.7825 11.5606L4.13606 11.9142L4.48961 12.2677L8.3787 16.1568L16.5104 8.02508L16.864 7.67153L17.2175 7.31798Z"/>
                  </svg>
                </div>
              </div>
              <figure class="PanelList-image" :style="'background-image: url(' + image.dataUrl + ');'"></figure>
            </div>
          </li>
          <li
            v-for="b in backgrounds" :key="b.uid" @click="onClickBg(b)"
            :class="[{'active': collage.bg.uid === b.uid}]"
          >
            <h3><span :data-size="b.title.length > 18 ? 'long' : 'short'">{{ b.title }}</span></h3>
            <div class="PanelList-imagewrapper">
              <LazyLoadImage :source="b.url" :alt="b.title"/>
              <!-- <figure class="PanelList-image" :style="'background-image: url(' + b.url + ');'"></figure> -->
              <div class="PanelList-overlay"></div>
              <div class="Marker" v-if="collage.bg.uid === b.uid">
                <svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.2175 7.31798C17.8033 6.73219 18.7531 6.73219 19.3389 7.31798C19.9246 7.90376 19.9246 8.85351 19.3389 9.4393L18.9853 9.79285L18.6317 10.1464L8.3787 20.3995L2.36829 14.389L2.01474 14.0355L1.66118 13.6819C1.0754 13.0962 1.0754 12.1464 1.66118 11.5606C2.24697 10.9748 3.19672 10.9748 3.7825 11.5606L4.13606 11.9142L4.48961 12.2677L8.3787 16.1568L16.5104 8.02508L16.864 7.67153L17.2175 7.31798Z"/>
                </svg>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

const ImageUploader = () => import('@/components/ImageUploader.vue')
const LazyLoadImage = () => import('@/components/LazyLoadImage.vue')
const CloseButton = () => import('@/components/CloseButton.vue')

export default {
  components: {
    CloseButton,
    ImageUploader,
    LazyLoadImage
  },
  data () {
    return {
      opened: null,
      collageOpened: false,
      bgOpened: false,
      isMobileOpened: false,
      hasImage: false,
      image: {
        dataUrl: null,
        uid: null
      },
      uploadCount: 0
    }
  },
  computed: {
    ...mapState({
      collage: 'collage',
      backgrounds: 'backgrounds',
      collages: 'sentences'
    })
  },
  created () {
  },
  methods: {
    onClose () {
      if (this.opened !== null) this.opened = null
    },
    setImage (output) {
      this.hasImage = true
      this.image = output
      const uid = 'custom' + this.uploadCount
      this.image.uid = uid
      this.$store.commit('SET_BG', {
        uid: uid,
        url: output.dataUrl
      })
      this.uploadCount++
    },
    onMobileBtn () {
      if (this.opened) this.opened = null
      else this.opened = 'collage'
    },
    onClickCollage (src) {
      this.$store.commit('SET_SENTENCE', src)
    },
    onClickBg (bg) {
      this.$store.commit('SET_BG', bg)
    }
  }
}
</script>

<style lang="stylus">

light-color = #FFFFFF
dark-color = #1b1b1b

.Panel
  position relative
  // background rgba(0, 0, 0, 0.5)
  z-index 6
  color light-color
  //&-wrapper
    //overflow hidden

  button
    display none
  nav
    text-transform uppercase
    display flex
    justify-content flex-end
    // transition all 200ms linear
    border-radius 32px
    border 1px solid dark-color

    color dark-color
    // overflow hidden
    &:hover
      .PanelNav-left
        margin-right 0px
        padding-right 36px

    a
      position relative
      white-space nowrap
      display block
      padding 22px 35px
      padding-bottom 21px
      transition background 200ms ease-out
      // border-right 1px solid dark-color
      //border-left 0
      cursor pointer
      font-size 1rem
      // transition background 200ms linear
      font-family 'LeagueMonoBold'
      background light-color
      border 1px solid white
      // background blue
      // clip-path polygon(0 0, 100% 0, 100% 90%, 60% 90%, 50% 100%, 40% 90%, 0 90%)

      // border-radius 50px
      // border-radius 20px

      &:hover
        // background rgba(0, 0, 0, 0.4)
        color red
        background black
        // box-shadow 0px 0px 1px 1px light-color inset
      &.open
        background dark-color
        color light-color
        .PanelNav-tick
          display block

    .PanelNav-tick
      position absolute
      width 10px
      height 10px
      border 1px solid white
      background dark-color
      bottom -5px
      left calc(50% - 5px)
      transform rotate(45deg)
      z-index 2
      display none

      &:after
        content ''
        position absolute
        width 20px
        height 10px
        background dark-color
        top -4px
        left -10px
        transform rotate(-45deg)
        transform-origin 50% 50%

    .PanelNav-left
        // border-right 0
        border-top-left-radius 30px
        border-bottom-left-radius 30px
        margin-right 1px

    .PanelNav-right
        border-top-right-radius 30px
        border-bottom-right-radius 30px
        // &:hover
        //   // border 1px solid white
        //   border-left 0

    .CloseButton
      position absolute
      left -40px
      top 20px

.Panel--opened
  nav
    border 0
    // border-top 1px solid light-color
    border-bottom-right-radius 0
    border-bottom-left-radius 0
    a
      padding-bottom 22px
      border-bottom 0
    .PanelNav-left
      border-bottom-left-radius 0px
      margin-right 0px
      padding-right 36px
    .PanelNav-right
      border-bottom-right-radius 0px
    // a
    //   &:hover
    //     border-right 1px solid light-color
    //   &:last-child
    //     border-right 0px

/*
    a
      &:last-child
        // border-right 2px solid light-color
        border-radius 20px
        border-top-left-radius 0
        border-bottom-right-radius 0
        border-bottom-left-radius 0
      &:first-child
        border-radius 20px
        border-top-right-radius 0
        border-bottom-right-radius 0
        border-bottom-left-radius 0
*/
.Panel-content
  background rgba(0, 0, 0, 0.7)
  width 100%
  max-height calc(100vh - 288px)
  overflow-y scroll
  position absolute
  border-radius 7px
  border-top-right-radius 0
  border 1px solid white
  width 559px
  right 0
  ul
    padding 10px
    li
      position relative
      margin 10px
    img
    figure
      display block
      width 100%

.Panel-collage
  ul
    li
      margin-bottom 30px
      display flex
      .image__wrapper
        width 80%
        margin-left 4%
        align-self center
      img
        position relative
        min-width auto
        min-height auto
        // max-height 100px
        // width auto

      > img
      > div
        align-self center

.Panel-bg
  ul
    display flex
    flex-wrap wrap
    li
      width calc(50% - 20px)
      margin 10px
      // border-radius 7px
      overflow hidden
    h3
      padding 10px 10px
      background white
      color black
      text-align left
      border-radius 7px
      border-bottom-left-radius 0
      border-bottom-right-radius 0
      white-space nowrap
      letter-spacing -0.1px
      span[data-size="long"]
        display inline-block
        white-space nowrap
        animation defilement-rtl 15s infinite linear
        transform-origin right center
        @keyframes defilement-rtl
          0%
            transform translate3d(0,0,0)
          100%
            transform translate3d(-50%,0,0)

    figure
      border-radius 7px
      border-top-left-radius 0
      border-top-right-radius 0
      border 1px solid white
      display inline-block
      height 0px
      width 100%
      padding-top 54%
    .UploadImage
      #fileInput
        display none
      figure
        border 1px dashed white
        border-top 1px solid white
      &-actions
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        display flex
        flex-wrap nowrap
        .Marker--plus
          border 1px solid white
          background rgba(0, 0, 0, 1)
          cursor pointer
          transition all 200ms linear
          margin 0 10px
          svg
            padding-bottom 0
            padding-left 1px
            fill white
          &:hover
            background rgba(255, 255, 255, 1)
            svg
              fill red
      &--active
        .PanelList-overlay
          opacity 1
    .active
      .PanelList-overlay
        opacity 1
      .Marker
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)

  .PanelList-imagewrapper
    position relative
  .PanelList-overlay
    position absolute
    width calc(100% - 2px)
    height calc(100% - 4px)
    border-bottom-left-radius 6px
    border-bottom-right-radius 6px
    top 1px
    left 1px
    background rgba(0,0,0,0.3)
    opacity 0
    transition opacity 200ms linear

.Marker
  width 60px
  height 60px
  border-radius 50%
  background rgba(255, 255, 255, 1)
  display flex
  align-items center
  justify-content center
  svg
    display block
    padding-bottom 4px
    fill black
  &--inactive
    border 1px solid white
    background none

@media (max-width: 660px)
  .Panel
    nav
      .CloseButton
        top 10px
      a
        padding 15px 18px
        padding-bottom 14px
        font-size 0.9rem
      &:hover
        .PanelNav-left
          padding-right 16px
    &-content
      width 93vw
      max-height 67vh
      right auto
      left 50%
      transform translate(-50%, 0)
      border-radius 7px
    &--opened
      nav
        .PanelNav-left
          padding-right 16px
  .Marker
    width 40px
    height 40px

  .Panel-bg
    ul
      h3
        font-size 3.2vw
      li
        width calc(50% - 10px)
        margin 5px
</style>
